/** @format */
import { Tooltip } from "@ui-library/core"
import styled from "styled-components"
import { colorPalette as colorPalette2, colors } from "_shared/styles/color"
import MemoSvgIconInfo from "@local/icons/component/IconInfo"

import { SkeletonLoaderDiv } from "_shared/styles/skeletonLoader"
import { IncrementCounterFixed } from "_components/atoms"

export const CreditsConsumedContainer = styled(SkeletonLoaderDiv)<{
	disabled: boolean
}>`
	display: grid;
	gap: 10px;

	p {
		margin: 0;
	}

	div {
		width: 45%;
	}
    color: ${props => props.disabled && colors.C15};
`

export const RegularText = styled.p`
	margin: 0;
	margin-bottom: 4px;
`

export const BoldText = styled.p`
	margin: 0;
	margin-bottom: 4px;
	font-weight: bold;
`

export const BoldSpan = styled.span`
	font-weight: bold;
`

export const GrayTextContainer = styled.div<{ disabled: boolean}>`
    color: ${props => props.disabled ? colors.C15 : "#707070"};
`;
export const BottomRegularText = styled.p`
	margin-bottom: 0;
`

export const StyledIncrementCounter = styled(IncrementCounterFixed)`
	width: 120px;

	div {
		border-color: ${colorPalette2.greyLightBis};
	}

	span {
		width: 300px;
	}
`

export const ReadOnlyIncrementCounter = styled(IncrementCounterFixed)`
	div[role="counter"] {
		background-color: white;
	}

    div, button, input{
        pointer-events:none;
        color: ${colors.C15};
    }

    width: 120px;


	div {
		border-color: ${colorPalette2.greyLightBis};
	}

	span {
		width: 300px;
	}
`

export const PagingContainer = styled.div`
	margin-top: 20px;
`
export const Container = styled.div`
	padding: 5px 20px 20px 20px;
`

export const InformationBadgeContainer = styled.div`
	padding: 10px;
`

export const MemberInformationsContainer = styled(SkeletonLoaderDiv)<{ disabled: boolean}>`
	min-height: 104px;
    color: ${props => props.disabled ? colors.C15 : "black"};
`
export const IncrementCounterContainer = styled(SkeletonLoaderDiv)``

export const IconTooltipContainer = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    width: 40px;
    margin-left: 10px;
`;

export const InfoIcon = styled(MemoSvgIconInfo)`
    height: 20px;
`;

export const WhiteTooltip = styled(Tooltip)`
    background-color: white;
    color: black;
    margin-left: -15px;
    div::after{
        background-color: white;
    }

	p {
		margin-top: 5px;
		margin-bottom: 5px;
	}

`;

export const DisabledRowContainer = styled.div`
    display: inline-flex;
`;

export const ModeAutoContainer = styled(SkeletonLoaderDiv)``